import React, { useEffect, useRef } from 'react';

const PageHeader = ({ title, subtitle, image }) => {
  const bgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        const scrolled = window.scrollY;
        bgRef.current.style.transform = `translateY(${scrolled * 0.5}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Parallax Background */}
      <div className="absolute inset-0 z-0">
        <div 
          ref={bgRef}
          className="absolute inset-0 w-full h-[120%] -top-[10%]"
          style={{
            backgroundImage: `url(${image || 'https://images.unsplash.com/photo-1624027492684-327af1fb7559?q=80&w=2070&auto=format&fit=crop'})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="absolute inset-0 bg-background/80 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-transparent to-background"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-center" data-aos="fade-up">
        <span className="inline-block py-1 px-3 border border-primary/30 rounded-full text-primary text-sm font-bold tracking-[0.2em] uppercase mb-6 backdrop-blur-sm">
          {subtitle}
        </span>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight">
          {title}
        </h1>
        <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
      </div>
    </div>
  );
};

export default PageHeader;
